/**
 * AUTO-GENERATED by tools/curriculum/generate-javascript-course-split-static-aliases.ts.
 * Source: content/curriculum-restructures/javascript-v1/plan.json
 * Static alias contract SHA-256: 8a4aa9d8225733dba78f997520bd5b8bf5d51bd67b95ab084d397e8a24c8997b
 *
 * The old lesson key remains the canonical static-asset identity during the
 * zero-downtime migration. New keys are lookup aliases, not duplicate assets.
 * Do not edit this file by hand.
 */

export interface JavascriptCourseSplitLessonAlias {
  lessonId: string;
  oldKey: string;
  newKey: string;
  oldCourseSlug: string;
  newCourseSlug: string;
  lessonSlug: string;
}

export const JAVASCRIPT_COURSE_SPLIT_STATIC_ALIAS_COUNT = 72 as const;
export const JAVASCRIPT_COURSE_SPLIT_STATIC_ALIAS_FINGERPRINT =
  "8a4aa9d8225733dba78f997520bd5b8bf5d51bd67b95ab084d397e8a24c8997b" as const;

export const JAVASCRIPT_COURSE_SPLIT_LESSON_ALIASES = Object.freeze([
  {
    lessonId: "31616250-1441-5fc9-8cdd-2b82bcb98f96",
    oldKey: "javascript-basics/js-addeventlistener",
    newKey: "javascript-dom/js-addeventlistener",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-addeventlistener",
  },
  {
    lessonId: "c7f6dc1d-8153-5fb8-8f4c-9b1e59f6a0ad",
    oldKey: "javascript-basics/js-array-basics",
    newKey: "javascript-core/js-array-basics",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-array-basics",
  },
  {
    lessonId: "17ee87dd-7491-4c3b-a99a-2e56722a55f8",
    oldKey: "javascript-basics/js-arrow-function",
    newKey: "javascript-core/js-arrow-function",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-arrow-function",
  },
  {
    lessonId: "4abeef2f-120b-4961-8cbb-664a84dbb2aa",
    oldKey: "javascript-basics/js-break-continue",
    newKey: "javascript-core/js-break-continue",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-break-continue",
  },
  {
    lessonId: "2b13ea04-6c21-47ce-a6e7-3574768d44ec",
    oldKey: "javascript-basics/js-callback",
    newKey: "javascript-core/js-callback",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-callback",
  },
  {
    lessonId: "b00341c4-998d-5107-8e6b-66910daeddc5",
    oldKey: "javascript-basics/js-ch4-build",
    newKey: "javascript-core/js-ch4-build",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-ch4-build",
  },
  {
    lessonId: "2c98f0c5-040e-5aec-833d-2ce711dc313c",
    oldKey: "javascript-basics/js-ch5-build",
    newKey: "javascript-core/js-ch5-build",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-ch5-build",
  },
  {
    lessonId: "2987c894-960a-55cd-8a49-eea42fff99b1",
    oldKey: "javascript-basics/js-ch6-build",
    newKey: "javascript-core/js-ch6-build",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-ch6-build",
  },
  {
    lessonId: "7cc5767f-9aa0-5ba8-84ec-bbb7ebf2a8ae",
    oldKey: "javascript-basics/js-ch7-build",
    newKey: "javascript-core/js-ch7-build",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-ch7-build",
  },
  {
    lessonId: "423b562a-3201-5460-8614-c315be53082e",
    oldKey: "javascript-basics/js-ch8-build",
    newKey: "javascript-dom/js-ch8-build",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-ch8-build",
  },
  {
    lessonId: "1f5fe767-f5ac-5dea-8d4c-12eab3a2c1e0",
    oldKey: "javascript-basics/js-ch9-build1",
    newKey: "javascript-dom/js-ch9-build1",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-ch9-build1",
  },
  {
    lessonId: "5616b944-e973-5514-8dbd-713802538402",
    oldKey: "javascript-basics/js-ch9-build2",
    newKey: "javascript-dom/js-ch9-build2",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-ch9-build2",
  },
  {
    lessonId: "30756995-986c-4ce1-b13e-a42fabf93e5b",
    oldKey: "javascript-basics/js-chapter4-quiz",
    newKey: "javascript-core/js-chapter4-quiz",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-chapter4-quiz",
  },
  {
    lessonId: "9125c358-13e1-42c8-ab92-15bdf1f2a49e",
    oldKey: "javascript-basics/js-chapter5-quiz",
    newKey: "javascript-core/js-chapter5-quiz",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-chapter5-quiz",
  },
  {
    lessonId: "da6b6988-de76-4dc1-9809-01fbfa01d163",
    oldKey: "javascript-basics/js-chapter6-quiz",
    newKey: "javascript-core/js-chapter6-quiz",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-chapter6-quiz",
  },
  {
    lessonId: "6a0c9794-efcd-5b03-8e9d-298f3e3ff56b",
    oldKey: "javascript-basics/js-chapter7-quiz",
    newKey: "javascript-core/js-chapter7-quiz",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-chapter7-quiz",
  },
  {
    lessonId: "fa08ffe6-b32a-506a-8c27-9fe232773bda",
    oldKey: "javascript-basics/js-chapter8-quiz",
    newKey: "javascript-dom/js-chapter8-quiz",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-chapter8-quiz",
  },
  {
    lessonId: "119fa11f-d324-5279-8037-2667ddffe090",
    oldKey: "javascript-basics/js-chapter9-quiz",
    newKey: "javascript-dom/js-chapter9-quiz",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-chapter9-quiz",
  },
  {
    lessonId: "4bdee9a0-9b85-5b75-8aaa-7f598002317a",
    oldKey: "javascript-basics/js-classlist",
    newKey: "javascript-dom/js-classlist",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-classlist",
  },
  {
    lessonId: "0f4db194-8a36-5318-8221-2855c48fa276",
    oldKey: "javascript-basics/js-create-append",
    newKey: "javascript-dom/js-create-append",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-create-append",
  },
  {
    lessonId: "536490da-9b71-4206-885d-534a29caf578",
    oldKey: "javascript-basics/js-default-params",
    newKey: "javascript-core/js-default-params",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-default-params",
  },
  {
    lessonId: "606d8747-a0ae-5d68-8b07-8ecace64adb6",
    oldKey: "javascript-basics/js-destructuring",
    newKey: "javascript-core/js-destructuring",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-destructuring",
  },
  {
    lessonId: "a42a85ef-d0ad-550f-8c04-0586026433da",
    oldKey: "javascript-basics/js-dom-intro",
    newKey: "javascript-dom/js-dom-intro",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-dom-intro",
  },
  {
    lessonId: "024118da-424f-5750-8299-db4ce5106760",
    oldKey: "javascript-basics/js-event-object",
    newKey: "javascript-dom/js-event-object",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-event-object",
  },
  {
    lessonId: "be3d4c97-6e09-5e74-820c-ceff192b1158",
    oldKey: "javascript-basics/js-final-extend",
    newKey: "javascript-dom/js-final-extend",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-final-extend",
  },
  {
    lessonId: "0f2bfc83-bcc3-54d7-8d57-25e108328be5",
    oldKey: "javascript-basics/js-final-next",
    newKey: "javascript-dom/js-final-next",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-final-next",
  },
  {
    lessonId: "1f7fd96a-ef76-5147-874f-9830a8bd09bf",
    oldKey: "javascript-basics/js-final-widget",
    newKey: "javascript-dom/js-final-widget",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-final-widget",
  },
  {
    lessonId: "fb6576b2-8105-4cad-9f83-9b47ff0f3b69",
    oldKey: "javascript-basics/js-find-includes",
    newKey: "javascript-core/js-find-includes",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-find-includes",
  },
  {
    lessonId: "021ae57e-3405-4d18-9c27-63aec1b9c391",
    oldKey: "javascript-basics/js-fizzbuzz",
    newKey: "javascript-core/js-fizzbuzz",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-fizzbuzz",
  },
  {
    lessonId: "7a1ca348-1037-459b-89aa-9fbe759a547a",
    oldKey: "javascript-basics/js-for-of",
    newKey: "javascript-core/js-for-of",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-for-of",
  },
  {
    lessonId: "decb3db2-aa7c-455e-a984-ed49831e8ed8",
    oldKey: "javascript-basics/js-for-sum",
    newKey: "javascript-core/js-for-sum",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-for-sum",
  },
  {
    lessonId: "c93ad845-ba04-54dd-867f-adbe2f29ef10",
    oldKey: "javascript-basics/js-foreach",
    newKey: "javascript-core/js-foreach",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-foreach",
  },
  {
    lessonId: "45dfc5ff-c4ff-475c-a45e-6b9e05f4a8cf",
    oldKey: "javascript-basics/js-function-declaration",
    newKey: "javascript-core/js-function-declaration",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-function-declaration",
  },
  {
    lessonId: "6d3e193f-287c-4467-894e-5190e2a5d45a",
    oldKey: "javascript-basics/js-guard-clause",
    newKey: "javascript-core/js-guard-clause",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-guard-clause",
  },
  {
    lessonId: "746ae2c5-66ab-4f76-99e4-89775d9256c5",
    oldKey: "javascript-basics/js-if-basic",
    newKey: "javascript-core/js-if-basic",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-if-basic",
  },
  {
    lessonId: "e4cdbac0-c78d-4ff9-82cd-aacd35507288",
    oldKey: "javascript-basics/js-if-elseif",
    newKey: "javascript-core/js-if-elseif",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-if-elseif",
  },
  {
    lessonId: "79b1948c-f9e1-485c-83f2-d5ee901d4816",
    oldKey: "javascript-basics/js-immutable-const",
    newKey: "javascript-core/js-immutable-const",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-immutable-const",
  },
  {
    lessonId: "212784e7-5291-5f30-8424-2608e51897b3",
    oldKey: "javascript-basics/js-input-value",
    newKey: "javascript-dom/js-input-value",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-input-value",
  },
  {
    lessonId: "41501c0d-bfdb-53e1-8e52-ae3b2a1d045c",
    oldKey: "javascript-basics/js-localstorage",
    newKey: "javascript-dom/js-localstorage",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-localstorage",
  },
  {
    lessonId: "e3e0a6d8-f7ee-4efc-b5f2-a24484ccacc1",
    oldKey: "javascript-basics/js-multi-return",
    newKey: "javascript-core/js-multi-return",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-multi-return",
  },
  {
    lessonId: "dbe358f5-688a-5f77-8556-a31f2cb2b802",
    oldKey: "javascript-basics/js-nested-conditions",
    newKey: "javascript-core/js-nested-conditions",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-nested-conditions",
  },
  {
    lessonId: "1ad88771-3130-5e5c-808b-d7b9eace6f11",
    oldKey: "javascript-basics/js-object-basics",
    newKey: "javascript-core/js-object-basics",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-object-basics",
  },
  {
    lessonId: "499e831d-27d7-44e7-b8ce-b6447537041b",
    oldKey: "javascript-basics/js-optional-chaining",
    newKey: "javascript-core/js-optional-chaining",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-optional-chaining",
  },
  {
    lessonId: "17af9a50-41e5-53ce-8329-6c2a0fba9f94",
    oldKey: "javascript-basics/js-push-pop",
    newKey: "javascript-core/js-push-pop",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-push-pop",
  },
  {
    lessonId: "88872687-df83-53dd-8454-d09c86004314",
    oldKey: "javascript-basics/js-queryselector",
    newKey: "javascript-dom/js-queryselector",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-queryselector",
  },
  {
    lessonId: "4bf1a2ad-919a-5d5c-8998-556cf26b09ec",
    oldKey: "javascript-basics/js-render-list",
    newKey: "javascript-dom/js-render-list",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-render-list",
  },
  {
    lessonId: "8d46ee87-b88c-51c9-8660-15e1c5426abe",
    oldKey: "javascript-basics/js-scope",
    newKey: "javascript-core/js-scope",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-scope",
  },
  {
    lessonId: "5b9daae1-f153-50ff-8eda-ab8796b051a8",
    oldKey: "javascript-basics/js-spread",
    newKey: "javascript-core/js-spread",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-spread",
  },
  {
    lessonId: "719b88eb-1bac-5780-8ef6-8ce8c6c6cca6",
    oldKey: "javascript-basics/js-submit-preventdefault",
    newKey: "javascript-dom/js-submit-preventdefault",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-submit-preventdefault",
  },
  {
    lessonId: "1a4b157f-1cb9-48c0-a441-1587c1c54cee",
    oldKey: "javascript-basics/js-switch",
    newKey: "javascript-core/js-switch",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-switch",
  },
  {
    lessonId: "8194144c-8284-53a2-805a-197eef2f6f36",
    oldKey: "javascript-basics/js-textcontent",
    newKey: "javascript-dom/js-textcontent",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-textcontent",
  },
  {
    lessonId: "34329000-c9c2-5a83-8921-0d97459d9af3",
    oldKey: "javascript-basics/js-timers",
    newKey: "javascript-dom/js-timers",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-dom",
    lessonSlug: "js-timers",
  },
  {
    lessonId: "0630e109-6012-4fae-9466-0bc6e0d9f37d",
    oldKey: "javascript-basics/js-while-countdown",
    newKey: "javascript-core/js-while-countdown",
    oldCourseSlug: "javascript-basics",
    newCourseSlug: "javascript-core",
    lessonSlug: "js-while-countdown",
  },
  {
    lessonId: "3d51994f-767f-4719-9b48-720b68685a8c",
    oldKey: "javascript-practical/jsp-async-await",
    newKey: "javascript-async-api/jsp-async-await",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-async-await",
  },
  {
    lessonId: "2f831600-2250-5831-8883-06401cf57b45",
    oldKey: "javascript-practical/jsp-async-errors",
    newKey: "javascript-async-api/jsp-async-errors",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-async-errors",
  },
  {
    lessonId: "1582b203-aac4-4153-a9da-ecfd6dd9ae8e",
    oldKey: "javascript-practical/jsp-async-quiz",
    newKey: "javascript-async-api/jsp-async-quiz",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-async-quiz",
  },
  {
    lessonId: "7a51e4dd-4ac1-5bf6-86da-6b29567e2fa3",
    oldKey: "javascript-practical/jsp-ch8-build",
    newKey: "javascript-async-api/jsp-ch8-build",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-ch8-build",
  },
  {
    lessonId: "479e6dd2-7bcd-5f81-8602-575c433d1df6",
    oldKey: "javascript-practical/jsp-ch9-build",
    newKey: "javascript-async-api/jsp-ch9-build",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-ch9-build",
  },
  {
    lessonId: "f09e80b7-2db0-47b0-91e1-ec6507780217",
    oldKey: "javascript-practical/jsp-fetch-basics",
    newKey: "javascript-async-api/jsp-fetch-basics",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-fetch-basics",
  },
  {
    lessonId: "99a81e1c-b877-4080-bc20-e6c0ec6db07b",
    oldKey: "javascript-practical/jsp-fetch-crud",
    newKey: "javascript-async-api/jsp-fetch-crud",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-fetch-crud",
  },
  {
    lessonId: "b9b80baf-2784-4959-8c3d-95b912e8f2d2",
    oldKey: "javascript-practical/jsp-fetch-error-handling",
    newKey: "javascript-async-api/jsp-fetch-error-handling",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-fetch-error-handling",
  },
  {
    lessonId: "89f3b661-30c0-5494-8adf-b0df2cc2b75f",
    oldKey: "javascript-practical/jsp-fetch-render",
    newKey: "javascript-async-api/jsp-fetch-render",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-fetch-render",
  },
  {
    lessonId: "6b00d90d-cc24-5dc9-88cd-248eba4f3e9f",
    oldKey: "javascript-practical/jsp-final-build",
    newKey: "javascript-async-api/jsp-final-build",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-final-build",
  },
  {
    lessonId: "8b78480b-f89f-5ed4-87b3-0b6622adc736",
    oldKey: "javascript-practical/jsp-final-next",
    newKey: "javascript-async-api/jsp-final-next",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-final-next",
  },
  {
    lessonId: "8d9b390f-1870-40e3-b74e-fd96b463a3bc",
    oldKey: "javascript-practical/jsp-http-quiz",
    newKey: "javascript-async-api/jsp-http-quiz",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-http-quiz",
  },
  {
    lessonId: "7f50542b-50e5-48c6-8c13-7e7a5d24f71b",
    oldKey: "javascript-practical/jsp-http-rest",
    newKey: "javascript-async-api/jsp-http-rest",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-http-rest",
  },
  {
    lessonId: "b132c64d-d441-443b-8382-aeab6d1414d1",
    oldKey: "javascript-practical/jsp-module-intro",
    newKey: "javascript-async-api/jsp-module-intro",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-module-intro",
  },
  {
    lessonId: "dc16ed26-2cdd-44f3-b6f9-fa7b05ddfcd1",
    oldKey: "javascript-practical/jsp-module-quiz",
    newKey: "javascript-async-api/jsp-module-quiz",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-module-quiz",
  },
  {
    lessonId: "57273339-5c60-49e2-8f0b-9c688797bfb1",
    oldKey: "javascript-practical/jsp-named-default-export",
    newKey: "javascript-async-api/jsp-named-default-export",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-named-default-export",
  },
  {
    lessonId: "bf8c12e1-69ad-4dc1-9f10-82593caeb02e",
    oldKey: "javascript-practical/jsp-promise-all",
    newKey: "javascript-async-api/jsp-promise-all",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-promise-all",
  },
  {
    lessonId: "b87f67c4-62ad-4b81-b078-6c6ac55f0950",
    oldKey: "javascript-practical/jsp-promise-basics",
    newKey: "javascript-async-api/jsp-promise-basics",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-promise-basics",
  },
  {
    lessonId: "54396006-cca6-44aa-aa6e-ec3c54a5a2ba",
    oldKey: "javascript-practical/jsp-sync-async",
    newKey: "javascript-async-api/jsp-sync-async",
    oldCourseSlug: "javascript-practical",
    newCourseSlug: "javascript-async-api",
    lessonSlug: "jsp-sync-async",
  },
]) satisfies readonly JavascriptCourseSplitLessonAlias[];

export const JAVASCRIPT_COURSE_SPLIT_OLD_TO_NEW_LESSON_KEY: Readonly<
  Record<string, string>
> = Object.freeze(
  Object.fromEntries(
    JAVASCRIPT_COURSE_SPLIT_LESSON_ALIASES.map(({ oldKey, newKey }) => [
      oldKey,
      newKey,
    ]),
  ),
);

export const JAVASCRIPT_COURSE_SPLIT_NEW_TO_OLD_LESSON_KEY: Readonly<
  Record<string, string>
> = Object.freeze(
  Object.fromEntries(
    JAVASCRIPT_COURSE_SPLIT_LESSON_ALIASES.map(({ oldKey, newKey }) => [
      newKey,
      oldKey,
    ]),
  ),
);

/** Stable identity used by static decks, figures, QA records, and CONTENT KV. */
export function canonicalJavascriptCourseSplitLessonKey(key: string): string {
  return JAVASCRIPT_COURSE_SPLIT_NEW_TO_OLD_LESSON_KEY[key] ?? key;
}

/** Both public lesson keys for moved lessons; one key for unaffected lessons. */
export function javascriptCourseSplitLessonKeyAliases(
  key: string,
): readonly string[] {
  const canonical = canonicalJavascriptCourseSplitLessonKey(key);
  const next = JAVASCRIPT_COURSE_SPLIT_OLD_TO_NEW_LESSON_KEY[canonical];
  return next ? [canonical, next] : [canonical];
}
